import styled, { css } from 'styled-components';

import { xdlPalettePetrol04 } from '@xing-com/tokens';

export const MenuItem = styled.li<{ $selected?: boolean }>`
  list-style-type: none;
  user-select: none;

  ${({ $selected }) =>
    $selected &&
    css`
      color: ${xdlPalettePetrol04};
    `}
`;

export const ItemButton = styled.button`
  cursor: pointer;
  font-size: 1.6em;
  height: 33px;
  overflow: hidden;
  text-align: right;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 300px;
`;

export const Container = styled.div<{ $isVisible: boolean }>`
  bottom: 0;
  justify-content: flex-end;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;

  ${({ $isVisible }) =>
    $isVisible
      ? css`
          display: flex;
        `
      : css`
          display: none;
        `}
`;
